import React from 'react';
import { MarketplaceOrderHistoryLogListTemplate } from 'themes/modules/order/pages';
import { MarketplaceOrderHistoryLogViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new MarketplaceOrderHistoryLogViewStore(rootStore), 'marketplaceOrderHistoryLogViewStore')
class MarketplaceOrderHistoryLogList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <MarketplaceOrderHistoryLogListTemplate {...this.props} headerCell={[]} />;
	}
}

export default MarketplaceOrderHistoryLogList;
